import { NgModule } from "@angular/core";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { CoreModule } from "../../../core/core.module";
import { ExportFileModule } from "../export-file/export-file.module";
import { PaginatorModule } from "../paginator/paginator.module";
import { SearchBarModule } from "../search-bar/search-bar.module";
import { DataTableComponent } from "./data-table.component";
import { DataTableService } from "./data-table.service";
import {
  ApplyFunctionOrReturn,
  CellRenderPipe,
  ColumnFunctionPipe,
  ExportDataPipe,
  LinkBuilderPipe,
  PipesInjectorPipe,
} from "./pipes";

@NgModule({
  declarations: [
    // Components
    DataTableComponent,
    // Pipes
    ApplyFunctionOrReturn,
    CellRenderPipe,
    ColumnFunctionPipe,
    ExportDataPipe,
    LinkBuilderPipe,
    PipesInjectorPipe,
  ],
  imports: [CoreModule, SearchBarModule, PaginatorModule, ExportFileModule, NgxDatatableModule],
  exports: [
    DataTableComponent,
    ApplyFunctionOrReturn,
    CellRenderPipe,
    ColumnFunctionPipe,
    ExportDataPipe,
    LinkBuilderPipe,
    PipesInjectorPipe,
  ],
  providers: [DataTableService],
})
export class DataTableModule {}
